import PropTypes from 'prop-types';

const TabPanel = ({ children, index, value }) => {
  if (index === value) {
    return <>{children}</>;
  }

  return <></>;
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number,
  value: PropTypes.number,
};

TabPanel.defaultProps = {
  children: undefined,
  index: undefined,
  value: undefined,
};

export default TabPanel;
